import * as React from 'react'
import { cn } from '@/lib/utils'

// Empty state — ui.jsx:239-253. 64px primary-container circle + icon,
// title, constrained text, optional action node.
export interface REmptyStateProps {
  /** Icon node (size ~30 to match the prototype). Colored on-primary-container. */
  icon: React.ReactNode
  title: React.ReactNode
  text?: React.ReactNode
  action?: React.ReactNode
  className?: string
}

export function REmptyState({ icon, title, text, action, className }: REmptyStateProps) {
  return (
    <div className={cn('px-6 py-[72px] text-center', className)}>
      <div className="mx-auto mb-[18px] flex h-16 w-16 items-center justify-center rounded-full bg-primary-container text-on-primary-container">
        {icon}
      </div>
      <div className="text-[18px] font-semibold text-ink">{title}</div>
      <p className="mx-auto mb-5 mt-2 max-w-[340px] text-ink-secondary">{text}</p>
      {action}
    </div>
  )
}
